"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var renderer_1 = require("@syl-editor/lib/dist/lib/renderer");
// ReactRenderer every card layer react instance correspond one
// to manage react life cycle
var ReactRenderer = /** @class */ (function () {
    function ReactRenderer(adapter, klass, container, name) {
        var _this = this;
        this.replaceProps = function (props, callback) {
            _this.props = {};
            _this.setProps(props, callback);
        };
        this.klass = klass;
        this.container = container;
        this.props = {};
        this.component = null;
        this.adapter = adapter;
        this.name = name;
        var rendererBridgeManager = renderer_1.rendererGlobalCache.get(this.adapter);
        rendererBridgeManager && rendererBridgeManager.add(this);
    }
    ReactRenderer.prototype.setProps = function (partialProps, callback) {
        if (this.klass === null) {
            console.warn("setProps(...): Can only update a mounted or " +
                "mounting component. This usually means you called setProps() on " +
                "an unmounted component. This is a no-op");
            return;
        }
        this.props = Object.assign({}, this.props, partialProps);
        var element = react_1.default.createElement(this.klass, this.props);
        this.component = react_dom_1.default.render(element, this.container, callback) || null;
    };
    ReactRenderer.prototype.unmount = function () {
        if (!this.container) {
            console.warn("unmount(void):void: Can only unmount when container exist");
            return;
        }
        react_dom_1.default.unmountComponentAtNode(this.container);
        this.klass = null;
    };
    ReactRenderer.prototype.uninstall = function () {
        var rendererBridgeManager = renderer_1.rendererGlobalCache.get(this.adapter);
        rendererBridgeManager && rendererBridgeManager.remove(this);
    };
    return ReactRenderer;
}());
exports.ReactRenderer = ReactRenderer;
//# sourceMappingURL=render-bridge.js.map